<template>
  <v-ons-dialog
    cancelable
    :visible.sync="dialogVisible"
    @posthide="afterHide"
  >
    <div class="alert-dialog-content">
      <img src="@/assets/img/rate-us.png" alt="Rate Us">
      <h4 style="text-align: center; margin-top: 0; margin-bottom: 1em;">{{ $t("rate_feedback.call_to_feedback") }}</h4>
      <p style="text-align: center; margin-top: 0;">{{ $t("rate_feedback.call_to_rate") }}</p>
      <img src="@/assets/img/5-stars.png" alt="5 Stars">
      <v-ons-button modifier="large cta" style="margin: 6px 0" @click="rateUs">{{ $t("rate_feedback.rate") }}</v-ons-button>
      <v-ons-button modifier="outline" style="margin: 6px 6px 6px 0" @click="showFeedbackPrompt">{{ $t("rate_feedback.feedback") }}</v-ons-button>
      <v-ons-button modifier="quiet" style="margin: 6px 0 6px 6px; color: grey;" @click="dialogVisible=false">{{ $t("rate_feedback.quit") }}</v-ons-button>
    </div>
  </v-ons-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },

  methods: {
    rateUs() {
      this.dialogVisible = false;
      window.LaunchReview.launch();
    },
    showFeedbackPrompt() {
      let that = this;
      this.dialogVisible = false;
      (new Promise((resolve) => {
        this.$ons.notification.prompt({
          message: this.$t("rate_feedback.feedback_dialog_title"),
          cancelable: true,
          title: '',
          callback: (feedback) => {
            resolve(feedback);
          },
        });
      })).then((feedback) => {
        if (!feedback) { return; }
        return that.currentUser.createFeedback(feedback);
      }).then((result) => {
        if (!result) { return; }
        that.$ons.notification.toast(that.$t("messages.feedback_received"), { timeout: 3000, animation: 'fall' });
      }).catch((error) => {
        console.log(error);
        that.showSomethingWrongToast();
      });
    },
    afterHide() {
      this.$destroy();
    },
  },

  mounted() {
    this.dialogVisible = true;
  },
};
</script>